import React from 'react'
import ManageBooks from '../manage-books/ManageBooks'
import { routeName } from '../../../../routes/routeName'
import { ELibraryCategory } from '../../enum/elibrary_enum'

type Props = {}

const ManageJournal: React.FC<Props> = (props: Props) => {
    return (
        <ManageBooks
            button_add_name='เพิ่มวารสาร'
            category={ELibraryCategory.MAGAZINE}
            menu_name={'จัดการวารสาร'}
            path_create={routeName.e_library.manage_journal_create}
        />
    )
}

export default ManageJournal